import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, ZapIcon, SmartphoneIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const includes = ['Ebook completo: Desayunos Sorpresa Rentables', 'Bono 1: Checklist de arranque', 'Bono 2: Plantilla de costos y precios', 'Bono 3: Guiones para WhatsApp', 'Bono 4: Paquetes y extras', 'Bono 5: Calendario de fechas', 'Bono 6: Fuentes y referencias'];
  // Timer logic
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  const [viewers, setViewers] = useState(31);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    const viewersTimer = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 3) - 1;
        const newViewers = prev + change;
        return newViewers >= 28 && newViewers <= 45 ? newViewers : prev;
      });
    }, 5000);
    return () => {
      clearInterval(timer);
      clearInterval(viewersTimer);
    };
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section id="offer-section" className="py-20 md:py-28 bg-coffee-dark relative overflow-hidden" data-id="element-179">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-180">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold-matte rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-181"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-taupe rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-182"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-184">
          <h2 className="text-4xl md:text-6xl font-extrabold text-cream-ivory mb-4 font-heading uppercase tracking-wide" data-id="element-185">
            Todo el paquete hoy
          </h2>
          <div className="w-32 h-2 bg-gold-matte mx-auto rounded-full mb-8" data-id="element-186"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-187">
          {/* Left Column: What you get */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-gold-matte" data-id="element-188">
            <a href="https://cocinaproductiva.com/products/libro" target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-189">
              <img src="https://cdn.magicpatterns.com/uploads/aLK8xhfR2MqhagaKkNjbdx/mockup_portada_ebook_2.png" alt="Ebook y Bonos" className="w-full max-w-sm mx-auto h-auto rounded-lg mb-8 drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-190" />
            </a>

            <h3 className="text-2xl font-bold text-coffee-dark mb-6 text-center border-b pb-4" data-id="element-191">
              Incluye:
            </h3>

            <div className="space-y-4" data-id="element-192">
              {includes.map((item, index) => <div key={index} className="flex items-start" data-id="element-193">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5" data-id="element-194">
                    <CheckIcon className="w-4 h-4 text-green-600 font-bold" data-id="element-195" />
                  </div>
                  <span className={index === 0 ? 'text-coffee-dark font-bold text-lg' : 'text-coffee font-medium text-lg'} data-id="element-196">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column: Pricing & CTA */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col items-center lg:items-start" data-id="element-197">
            {/* Urgency Elements */}
            <div className="w-full mb-8" data-id="element-198">
              <div className="flex flex-wrap justify-center lg:justify-start items-center gap-3 mb-4" data-id="element-199">
                <span className="bg-red-600 text-white px-4 py-2 rounded-md font-bold text-sm animate-pulse shadow-lg" data-id="element-200">
                  ¡EL PRECIO ESTÁ POR SUBIR!
                </span>
                <span className="bg-white/10 text-cream-ivory px-4 py-2 rounded-md text-sm font-medium border border-white/20" data-id="element-201">
                  <span className="font-bold text-gold-matte" data-id="element-202">{viewers}</span>{' '}
                  personas están viendo esto
                </span>
              </div>

              <div className="bg-red-600/20 border border-red-500/50 text-white p-4 rounded-xl text-center lg:text-left backdrop-blur-sm" data-id="element-203">
                <p className="mb-2 text-sm font-medium" data-id="element-204">
                  La oferta se termina en:
                </p>
                <div className="text-5xl font-black leading-none font-heading tracking-wider text-gold-matte drop-shadow-md" data-id="element-205">
                  {formatTime(timeLeft)}
                </div>
              </div>
            </div>

            {/* Pricing */}
            <div className="bg-white rounded-3xl p-8 shadow-2xl w-full text-center relative overflow-hidden" data-id="element-206">
              <div className="absolute top-0 right-0 bg-red-600 text-white font-bold py-1 px-10 transform translate-x-8 translate-y-4 rotate-45 shadow-md" data-id="element-207">
                75% OFF
              </div>

              <p className="text-taupe font-bold uppercase tracking-widest text-sm mb-2" data-id="element-208">
                VALOR REFERENCIA: <span className="line-through" data-id="element-209">$60.999</span>
              </p>

              <div className="mb-6" data-id="element-210">
                <p className="text-xl text-coffee-dark font-bold mb-1" data-id="element-211">
                  Hoy por solo:
                </p>
                <p className="text-7xl font-black text-green-600 font-heading drop-shadow-sm" data-id="element-212">
                  $14.999
                </p>
                <p className="text-sm font-bold text-coffee mt-2 bg-green-100 inline-block px-4 py-1 rounded-full" data-id="element-213">
                  Ahorrá un 75%
                </p>
              </div>

              <div className="mb-8 border-t border-b border-beige-sand py-4" data-id="element-214">
                <p className="text-lg font-extrabold text-coffee-dark flex items-center justify-center gap-2" data-id="element-215">
                  💳 3 cuotas sin interés
                </p>
                <p className="text-xs text-taupe mt-1" data-id="element-216">
                  con Mercado Pago (sujeto a promociones vigentes)
                </p>
              </div>

              <div className="w-full" data-id="element-217">
                <CTAButton size="large" fireAddToCart={true} className="w-full text-xl py-6 shadow-[0_0_20px_rgba(147,197,114,0.5)]" data-id="element-218">
                  COMPRAR AHORA — MERCADO PAGO
                </CTAButton>
              </div>

              <div className="flex justify-center gap-6 mt-6 text-xs text-taupe font-medium" data-id="element-219">
                <div className="flex items-center" data-id="element-220">
                  <ShieldCheckIcon className="w-4 h-4 mr-1 text-green-500" data-id="element-221" />{' '}
                  Pago seguro
                </div>
                <div className="flex items-center" data-id="element-222">
                  <ZapIcon className="w-4 h-4 mr-1 text-gold-matte" data-id="element-223" /> Acceso
                  digital
                </div>
              </div>

              <p className="text-xs text-taupe-light mt-4" data-id="element-224">
                Si tenés dudas del proceso de compra, escribinos a soporte.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Urgency Explanation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-225">
          <h4 className="text-2xl font-bold text-gold-matte mb-4 font-heading" data-id="element-226">
            Por qué este precio no se mantiene para siempre
          </h4>
          <p className="text-cream-ivory text-lg leading-relaxed" data-id="element-227">
            Este valor con 75% OFF es una oferta de lanzamiento / por tiempo
            limitado para quienes quieren empezar ya. Cuando lo subamos, el
            paquete volverá a su precio habitual.
          </p>
        </motion.div>
      </div>
    </section>;
}